export const sendReferralInvite = (axiosInstance, referralInvitePostBody) => {
    const url = 'v1/referral/invite';
    return axiosInstance.post(url, referralInvitePostBody);
};

export const getReferralLandingMember = (axiosInstance, codeSlug) => {
    const url = `v2/referrals/landing/member/${encodeURIComponent(codeSlug)}`;
    return axiosInstance.get(url);
};

export const getReferralLandingClub = (axiosInstance, codeSlug) => {
    const url = `v2/referrals/landing/club/${encodeURIComponent(codeSlug)}`;
    return axiosInstance.get(url);
};

export const getReferralMember = (axiosInstance) => {
    const url = 'v2/referrals/member';
    return axiosInstance.get(url);
};

export const getReferralClub = (axiosInstance, clubId) => {
    const url = `v2/referrals/club/${encodeURIComponent(clubId)}`;
    return axiosInstance.get(url);
};

export const applyReferralCode = (axiosInstance, body) => {
    const url = 'v2/referrals/apply';
    return axiosInstance.post(url, body);
};

export const clearReferralCode = (axiosInstance) => {
    const url = 'v2/referrals/clear';
    return axiosInstance.post(url);
};
